import api from "../../../utils/api";
import { setAlert } from "../alert";
import { handleError } from "../errors";
import {
  ACCEPT_REJECT_CHANGE_REQUEST,
  ACCEPT_REJECT_CHANGE_REQUEST_ERROR,
  BULK_ACTION_CHANGE_REQUEST,
  BULK_ACTION_CHANGE_REQUEST_ERROR,
  DELETE_CHANGE_REQUEST_NOTE,
  DELETE_CHANGE_REQUEST_NOTE_ERROR,
  GET_CHANGE_REQUEST_BULK_ACTIONS,
  GET_CHANGE_REQUEST_BULK_ACTIONS_ERROR,
  GET_CHANGE_REQUEST_DETAIL,
  GET_CHANGE_REQUEST_DETAIL_ERROR,
  GET_CHANGE_REQUEST_LIST,
  GET_CHANGE_REQUEST_LIST_ERROR,
  GET_CHANGE_REQUEST_STATUS_LIST,
  GET_CHANGE_REQUEST_STATUS_LIST_ERROR,
  SAVE_CHANGE_REQUEST_NOTE,
  SAVE_CHANGE_REQUEST_NOTE_ERROR,
} from "../types";

export const get_change_request_list = (filters = {}) => async (dispatch) => {
  try {
    const res = await api.get("api/sub-changerequest/get-change-request-list", {
      params: filters,
    });
    dispatch({
      type: GET_CHANGE_REQUEST_LIST,
      payload: res.data,
    });
  } catch (err) {
    handleError(err, dispatch);
    dispatch({
      type: GET_CHANGE_REQUEST_LIST_ERROR,
    });
  }
};

export const get_change_request_bulk_actions = () => async (dispatch) => {
  try {
    const res = await api.get(
      "api/sub-changerequest/get-change-request-bulk-action-names"
    );
    dispatch({
      type: GET_CHANGE_REQUEST_BULK_ACTIONS,
      payload: res.data,
    });
  } catch (err) {
    handleError(err, dispatch);
    dispatch({
      type: GET_CHANGE_REQUEST_BULK_ACTIONS_ERROR,
    });
  }
};

export const get_change_request_status_list = () => async (dispatch) => {
  try {
    const res = await api.get(
      "api/sub-changerequest/get-change-request-status-list"
    );
    dispatch({
      type: GET_CHANGE_REQUEST_STATUS_LIST,
      payload: res.data,
    });
  } catch (err) {
    handleError(err, dispatch);
    dispatch({
      type: GET_CHANGE_REQUEST_STATUS_LIST_ERROR,
    });
  }
};

export const bulk_action_change_request = (bulkData) => async (dispatch) => {
  try {
    const res = await api.post(
      "api/sub-changerequest/bulk-action-change-request",
      bulkData
    );
    dispatch({
      type: BULK_ACTION_CHANGE_REQUEST,
    });
    dispatch(setAlert(res.data.message, "success"));
    return true;
  } catch (err) {
    handleError(err, dispatch);
    dispatch({
      type: BULK_ACTION_CHANGE_REQUEST_ERROR,
    });
    return false;
  }
};

export const get_change_request = (refNum) => async (dispatch) => {
  try {
    const res = await api.get("api/sub-changerequest/get-change-request", {
      params: { refNum },
    });
    dispatch({
      type: GET_CHANGE_REQUEST_DETAIL,
      payload: res.data,
    });
  } catch (err) {
    handleError(err, dispatch);
    dispatch({
      type: GET_CHANGE_REQUEST_DETAIL_ERROR,
    });
  }
};

export const save_change_request_note = (noteData) => async (dispatch) => {
  try {
    const res = await api.post(
      "api/sub-changerequest/save-change-request-note",
      noteData
    );
    dispatch({ type: SAVE_CHANGE_REQUEST_NOTE });
    dispatch(setAlert(res.data.message || "Note saved.", "success"));
    return true;
  } catch (err) {
    handleError(err, dispatch);
    dispatch({ type: SAVE_CHANGE_REQUEST_NOTE_ERROR });
    return false;
  }
};

export const delete_change_request_note = (deleteData) => async (dispatch) => {
  try {
    const res = await api.post(
      "api/sub-changerequest/delete-change-request-note",
      deleteData
    );
    dispatch({ type: DELETE_CHANGE_REQUEST_NOTE });
    dispatch(setAlert(res.data.message || "Note deleted.", "success"));
    return true;
  } catch (err) {
    handleError(err, dispatch);
    dispatch({ type: DELETE_CHANGE_REQUEST_NOTE_ERROR });
    return false;
  }
};

//complete change request
export const complete_change_request = (data) => async (dispatch) => {
  try {
    const res = await api.post(
      "api/sub-changerequest/complete-change-request",
      data
    );
    dispatch({ type: ACCEPT_REJECT_CHANGE_REQUEST });
    dispatch(setAlert(res.data.message || "Changes submitted.", "success"));
    return true;
  } catch (err) {
    handleError(err, dispatch);
    dispatch({ type: ACCEPT_REJECT_CHANGE_REQUEST_ERROR });
    return false;
  }
};
